import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import Header from 'Components/common/Header';
import {T} from 'Actions/translate';
import {setDefaultSCData} from 'Actions/localData';
import {getSCList} from 'Actions/replenishment';
import ReplenishmentSCCard from 'Components/replenishment/ReplenishmentSCCard';
import LoadingIcon from 'Components/icons/LoadingIcon';
import logo from 'Images/logo_bottom.png';

class ReplenishmentManagement extends Component {
    state = {
        listLoaded: true,
    };

    componentDidMount() {
        this.props.getSCList({type: 2}, this.hideloading);
    }

    hideloading = () => {
        this.setState({
            listLoaded: false,
        });
    };

    chooseSC = (scDetails) => {
        this.props.setDefaultSCData(
            {
                supplyCenterId: scDetails ? scDetails.id : '',
                supplyCenterName: scDetails ? scDetails.name : '',
                type: 2,
            },
            this.goToSCDetails,
        );
    };

    goToSCDetails = () => this.props.history.push('/replenishmentSCDetails');
    goBack = () => this.props.history.push('/userCenter');

    render() {
        const {listLoaded} = this.state;
        const {replenishmentSCList, localData} = this.props;

        return (
            <div className="replenishment-mgmt">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>
                                {localData.roleType === 3
                                    ? T('fone_order_view_inventory')
                                    : T('replenishmentMgmt')}
                            </span>
                        </Grid>
                    </Grid>
                </Header>

                {listLoaded ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <Grid
                        className="note-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid item xs={11}>
                            {replenishmentSCList &&
                                replenishmentSCList.map((item) => (
                                    <ReplenishmentSCCard
                                        key={item.number}
                                        scDetails={item}
                                        chooseSC={this.chooseSC}
                                    />
                                ))}
                            <div className="abyss-sect">
                                <div className="hr-sect">
                                    <span className="finish-line">
                                        {T('already_in_the_bottom')}
                                    </span>
                                </div>
                                <div className="image-sect">
                                    <img
                                        src={logo}
                                        className="logo"
                                        alt="tfc logo"
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {replenishment, localData} = state;

    return {
        replenishmentSCList: replenishment.replenishmentSCList,
        localData,
    };
};

const mapDispatchToProps = {
    getSCList,
    setDefaultSCData,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReplenishmentManagement);
